<script setup lang="ts">
import type BreadCrumb from '@/types/BreadCrumb';

defineProps<{
    breadCrumbs: BreadCrumb[];
    currentPage: string;
}>();
</script>
<template>
    <div class="bread-crumbs q-mt-lg q-ml-lg">
        <span
            v-for="(crumb, index) in breadCrumbs"
            :key="index"
            class="bread-crumb-linked"
        >
            <router-link :to="crumb.to">
                {{ crumb.label }}
            </router-link> /
        </span>
        {{ currentPage }}
    </div>
</template>
<style scoped>
div.bread-crumbs {
    font-size: 12px;
    text-align: left;
}
div.bread-crumbs a {
    text-decoration: none;
    color: var(--fsum-secondary-blue);
}
</style>
